<template>
  <section style="padding:20px;">

    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="消息标题" style="width:300px;" icon="circle-close"
                    :on-icon-click="cleanFilter"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getMessages">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table :data="messages" border highlight-current-row v-loading="listLoading" :row-class-name="tableRowClassName"
              style="width: 100%;" @row-click="rowClick">
      <el-table-column header-align="center" prop="title" label="标题" align="center" min-width="150">
      </el-table-column>
      <el-table-column header-align="center" prop="content" label="内容" min-width="300">
      </el-table-column>
      <el-table-column prop="createdAt" label="通知时间" :formatter="formatTime" width="120" align="center">
      </el-table-column>
      <el-table-column label="状态" width="150" align="center">
        <template scope="scope">
          <el-tag v-if="scope.row.state === 0"
                  type="gray"
                  close-transition>未读</el-tag>
          <el-tag v-if="scope.row.state === 1"
                  type="success"
                  close-transition>已读</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>

  </section>
</template>

<script>
  import util from '../../common/js/util'
  import moment from 'moment'
  import bcrypt from 'bcryptjs'
  //import NProgress from 'nprogress'
  import {getMessageList,read} from '../../api/api';
  import Bus from '../../bus.js';

  export default {
    data() {
      return {
        filters: {
          name: ''
        },
        messages: [],
        total: 0,
        page: 1,
        listLoading: false,
      }
    },
    filters: {

    },
    methods: {
      cleanFilter() {
        this.filters.name = '';
        this.getMessages();
      },
      formatTime: function (row, column) {
        return moment(row.createdAt).format('YYYY-MM-DD');
      },
      tableRowClassName(row, index) {
        if (row.state === 0)
          return 'rowClass';
        return '';
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getMessages();
      },
      rowClick: function (row, event, column) {
        if (row.state == 0) {
          read({
            id: row.id
          }).then((res) => {
            this.getMessages();
            Bus.$emit('reloadUnreadCount', '已读成功！');
          });
        }
      },
      //获取企业列表
      getMessages() {
        let para = {
          page: this.page,
          size: 10,
          name: this.filters.name
        };
        this.listLoading = true;
        //NProgress.start();
        getMessageList(para).then((res) => {
          this.total = res.data.total;
          this.messages = res.data.list;
          this.listLoading = false;
          //NProgress.done();
        });
      },
    },
    mounted() {
      this.getMessages();
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Message.vue?7e82cef3